import catalogoService from '../../services/catalogo/CatalogoService'

export const catalogoModule = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async searchClientes({}, params) {
      return await catalogoService.searchClientes(params)
    },
    async listCatalogs({}, params) {
      return await catalogoService.listCatalogs(params)
    },
    async toggleCatalogValid({}, hashid) {
      return await catalogoService.toggleValid(hashid)
    },
    async generateLink({}, payload) {
      return await catalogoService.generateLink(payload)
    },
    async fetchPublicCatalog({}, hashid) {
      return await catalogoService.getPublicCatalog(hashid)
    },
    async fetchPublicCatalogItems({}, { hashid, params }) {
      return await catalogoService.getPublicCatalogItems(hashid, params)
    },
    async fetchPublicCatalogCart({}, hashid) {
      return await catalogoService.getPublicCatalogCart(hashid)
    },
    async savePublicCatalogCart({}, { hashid, payload }) {
      return await catalogoService.savePublicCatalogCart(hashid, payload)
    },
    async getCatalogDetails({}, hashid) {
      return await catalogoService.getCatalogDetails(hashid)
    },
    async resendCatalogEmail({}, { hashid, id }) {
      return await catalogoService.resendCatalogEmail(hashid, id)
    },
    async finishPublicCatalogOrder({}, payload) {
      const { hashid, email, tipoLiberacao } = payload || {}
      return await catalogoService.finishPublicCatalogOrder(
        hashid,
        email || '',
        tipoLiberacao
      )
    },
  },
  getters: {},
}